/* istanbul ignore file */
"use client";

import { ISpecificationCategoryResponse } from "@/shared/services/interface/responses/ISpecificationResponse";
import RenderCollapsible from "./category-collapsible/category-collapsible";
import SpecificationSidebarSkeleton from "../skeleton";
import { useSelector } from "@/core/redux/store";

export function SpecificationCategoryList({
  categories,
  parentPriority,
  parentId = null,
}: {
  categories: ISpecificationCategoryResponse[];
  parentPriority?: string;
  parentId?: string | null;
}) {
  const skeletonLoading = useSelector(
    (state) => state.specification.skeletonLoading
  );

  return (
    <div className="pt-0 overflow-auto max-h-[calc(100svh-149px)] px-2">
      <ul className="flex flex-col gap-0">
        {categories?.map((item, index) => (
          <RenderCollapsible
            item={item}
            key={item.id}
            priority={
              parentPriority ? `${parentPriority}.${index + 1}` : `${index + 1}`
            }
            parentId={parentId}
          />
        ))}
        {categories?.length === 0 && skeletonLoading && (
          <SpecificationSidebarSkeleton />
        )}
      </ul>
    </div>
  );
}

export default SpecificationCategoryList;
